import { render, staticRenderFns } from "./offers.vue?vue&type=template&id=6d4c6ece&"
import script from "./offers.vue?vue&type=script&lang=js&"
export * from "./offers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d4c6ece')) {
      api.createRecord('6d4c6ece', component.options)
    } else {
      api.reload('6d4c6ece', component.options)
    }
    module.hot.accept("./offers.vue?vue&type=template&id=6d4c6ece&", function () {
      api.rerender('6d4c6ece', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2k9vtGYn280ac/JS/comp/offers.vue"
export default component.exports